module.exports = __webpack_public_path__ + "img/yes.e4de24d.svg";